import { Component, OnInit, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';

@Component({
    selector: 'app-chat-bubble',
    templateUrl: './chat-bubble.component.html',
    styleUrls: ['./chat-bubble.component.scss']
})
export class ChatBubbleComponent implements OnInit, AfterViewChecked {
    @ViewChild('messagesContainer') private messagesContainer: ElementRef;

    isChatOpen = false;
    messages: { text: string, isUser: boolean, isWelcome?: boolean }[] = [];
    userMessage = '';

    constructor() { }

    ngOnInit(): void {
        // Add initial welcome message
        this.messages.push({
            text: 'Hello! I\'m your AI assistant. How can I help you today?',
            isUser: false,
            isWelcome: true
        });
    }

    ngAfterViewChecked() {
        this.scrollToBottom();
    }

    scrollToBottom(): void {
        try {
            this.messagesContainer.nativeElement.scrollTop =
                this.messagesContainer.nativeElement.scrollHeight;
        } catch (err) { }
    }

    toggleChat(): void {
        this.isChatOpen = !this.isChatOpen;
        // Allow time for animation and then scroll to bottom
        if (this.isChatOpen) {
            setTimeout(() => {
                this.scrollToBottom();
            }, 300);
        }
    }

    isWelcomeMessage(message: any): boolean {
        return message.isWelcome === true;
    }

    sendMessage(): void {
        if (this.userMessage.trim() === '') {
            return;
        }

        // Add user message
        this.messages.push({
            text: this.userMessage,
            isUser: true
        });

        const userQuery = this.userMessage;
        this.userMessage = '';

        // Simulate AI response (you would replace this with actual API call)
        setTimeout(() => {
            this.messages.push({
                text: `I received your message: "${userQuery}". I'm an AI assistant ready to help with your questions.`,
                isUser: false
            });
        }, 1000);
    }

    handleKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendMessage();
        }
    }
}